// components/job/stats/timesheet/api.js
import { getItemFromCollection } from "directus/src/operations";

export async function fetchBillableHoursForMilestone({ id }) {
  try {
      const query = {
        fields: [
          "id",
          "billable_hours",
        ],
      };
  
      const data = await getItemFromCollection("milestones", id, query);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
}
